import React from 'react';

const MailIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5v10.5H3.75V6.75Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 7.5 7.5 6 7.5-6" />
  </svg>
);

const LocationIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 5.25-7.5 10.5-7.5 10.5S4.5 15.75 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
    <circle cx="12" cy="10.5" r="2.5" />
  </svg>
);

const CielGoSection = () => {
  return (
    <section className="bg-white px-6 py-20 lg:px-8" aria-labelledby="ciel-go-heading">
      <div className="mx-auto max-w-7xl overflow-hidden rounded-[2rem] border border-[#EAD8B1]/70 bg-[#FAF7F0] shadow-[0_24px_70px_rgba(7,26,43,0.08)]">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr]">
          <div className="flex min-h-[300px] items-center justify-center bg-white p-8 sm:p-12 lg:p-16">
            <img
              src="/assets/img/ciel-go-logo.png"
              alt="Ciel Go — Bon Voyage"
              className="w-full max-w-md object-contain"
            />
          </div>

          <div className="relative flex flex-col justify-center overflow-hidden bg-[#071A2B] p-8 text-white sm:p-12 lg:p-16">
            <div aria-hidden="true" className="absolute -right-20 -top-20 h-64 w-64 rounded-full border border-[#D6A84B]/20" />
            <div aria-hidden="true" className="absolute -bottom-28 -right-10 h-64 w-64 rounded-full bg-[#D6A84B]/10 blur-3xl" />

            <div className="relative">
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#D6A84B]">Travel assistance</p>
              <h2 id="ciel-go-heading" className="mt-3 font-playfair text-3xl text-white sm:text-4xl">Connect with Ciel Go</h2>
              <p className="mt-4 max-w-xl text-sm leading-7 text-white/70 sm:text-base">
                Reach the Ciel Go team for travel operations, coordination and support from their Trivandrum office.
              </p>

              <div className="mt-8 gap-4 sm:grid-cols-2">
                <a
                  href="mailto:operations@cielgo.com"
                  className="group flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.06] p-4 transition hover:border-[#D6A84B]/60 hover:bg-white/10"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#D6A84B] text-[#071A2B]">
                    <MailIcon />
                  </span>
                  <span className="min-w-0">
                    <span className="block text-xs uppercase tracking-wider text-white/50">Operations</span>
                    <span className="mt-1 block break-all text-sm font-medium text-white group-hover:text-[#EAD8B1]">operations@cielgo.com</span>
                  </span>
                </a>

                
              </div>

              <div className="mt-4 flex gap-3 rounded-2xl border border-white/10 bg-white/[0.06] p-4 sm:p-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#D6A84B] text-[#071A2B]">
                  <LocationIcon />
                </span>
                <address className="not-italic">
                  <span className="block text-xs uppercase tracking-wider text-white/50">Office address</span>
                  <span className="mt-1 block text-sm leading-6 text-white/85">
                    Gurupriya Building, NH Bypass Jn, Near Phase 01 Technopark,<br className="hidden sm:block" />
                    Kazhakkoottam P.O, Trivandrum, Kerala – 695582
                  </span>
                </address>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CielGoSection;
